import { tamarackAPI, processApiResponse } from "./Tamarack";

export const PickListDataAPI = {
    async getPickList(searchObj) {
        if (searchObj && typeof searchObj !== "object") {
            throw new Error("Search object must be key value type ex: {status: 'Funding'}");
        }
        let searchCriteria = "";
        if (searchObj) {
            let keys = Object.keys(searchObj);
            searchCriteria = `?${keys[0]}=${searchObj[keys[0]]}`;
            for (let i = 1; i < keys.length; i++) {
                searchCriteria = `${searchCriteria}&${keys[i]}=${searchObj[keys[i]]}`;
            }
        }
        const path = `picklistValues${searchCriteria}`;
        const response = await tamarackAPI.get(path);
        return processApiResponse(response, "get", path);
    },
};
